export default "<p>create-workreport-dialog works!</p>\n"